/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

const IconAdd = (props) => (
  <svg width={props.size} height={props.size} viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="10" style={{ strokeWidth: '1.25', strokeMiterLimit: 10 }} className={`${props.strokeClassName} ${props.fillClassName}`} />
    <path d="M12 8v8M16 12H8" style={{ strokeWidth: '1.25', strokeMiterLimit: 10 }} className={props.strokeClassName} />
    <g style={{ display: 'none' }}>
      <path d="M22 0H0v24h24V0h-2zm0 22H2V2h20v20z" style={{ display: 'inline', opacity: '.5' }} />
    </g>
  </svg>
);
IconAdd.propTypes = {
  fillClassName: PropTypes.string,
  strokeClassName: PropTypes.string,
  size: PropTypes.string,
};

export default IconAdd;
